import { render, staticRenderFns } from "./ScoreChip.vue?vue&type=template&id=1bcb66e7"
import script from "./ScoreChip.vue?vue&type=script&lang=js"
export * from "./ScoreChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports